"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientSourceTypes = void 0;
var patientSourceTypes;
(function (patientSourceTypes) {
    patientSourceTypes["OLD_IMPORT"] = "oldImport";
    patientSourceTypes["NEW_IMPORT"] = "newImport";
    patientSourceTypes["SINGLE"] = "single";
    patientSourceTypes["BEHEALTHY_SYNCHRONOUS"] = "behealthySynchronous";
    patientSourceTypes["RANDOM_PATIENT"] = "randomPatient";
    patientSourceTypes["SYNCHRONOUS"] = "synchronous";
})(patientSourceTypes || (exports.patientSourceTypes = patientSourceTypes = {}));
